import http from "../../../service/axios/httpRequest";

const AI_AGENTS_ENDPOINT = "/direct/ai-agent";
const AI_RESPONSE_ENDPOINT = "/ai-response-bff";

export const getAllIAsRequest = async () => {
    return await http.get(AI_AGENTS_ENDPOINT).then(response => response.data);
};

export const createIARequest = async (body) => {
    return await http.post(AI_AGENTS_ENDPOINT, body).then(response => response.data);
};

export const editIARequest = async (body) => {
    return await http.put(`${AI_AGENTS_ENDPOINT}/${body.id}`, body).then(response => response.data);
};

export const deleteIARequest = async (id) => {
    return await http.delete(`${AI_AGENTS_ENDPOINT}/${id}`).then(response => response.data);
};

export const runIAAgentRequest = async (agentId, input, zoneId) => {
    return await http.post(`${AI_RESPONSE_ENDPOINT}/${agentId}/run`, { input, zoneId }).then(response => response.data);
};

export const getAllZonesRequest = async () => {
    return await http.get('/direct/zone').then(response => response.data);
};

export const getAgentZonesRequest = async (agentId) => {
    return await http.get(`/bff/ai-agent-bff/agent/${agentId}/zones`).then(response => response.data);
};

export const toggleAgentZoneRequest = async ({ zoneId, agentId }) => {
    return await http.post(`/bff/ai-agent-bff/zone/${zoneId}/agent/${agentId}/toggle`).then(response => response.data);
};

export const addAgentFilesRequest = async (agentId, files) => {
    return await http.post(`${AI_AGENTS_ENDPOINT}/${agentId}/files`, { files }).then(response => response.data);
};

export const removeAgentFileRequest = async (agentId, fileId) => {
    return await http.delete(`${AI_AGENTS_ENDPOINT}/${agentId}/files/${fileId}`);
};
